// extracted by mini-css-extract-plugin
export default {"wrapper":"fade-gallery_wrapper__ZPbTz","bg":"fade-gallery_bg__s3+uA","logo":"fade-gallery_logo__a9LMR"};